(function(){
  var b = document.body;
  var p = window.location.pathname;

  // Collection pages - detect from URL
  if (p.indexOf('/collections/') === 0) {
    if (p.indexOf('electronics') > -1 || p.indexOf('phone') > -1 ||
        p.indexOf('boox') > -1 || p.indexOf('accessories') > -1 ||
        p.indexOf('speakers') > -1 || p.indexOf('cables') > -1 ||
        p.indexOf('gaming') > -1) {
      b.classList.add('brand-electronics');
    } else {
      b.classList.add('brand-electronics');
    }
  }

  // Product pages - detect from product data
  if (p.indexOf('/products/') > -1) {
    // Helper: classify from vendor + type + tags strings
    function classify(vendor, type, tags) {
      var v = (vendor || '').toLowerCase();
      var t = (type || '').toLowerCase();
      // tags might be array or comma-string
      var tg = '';
      if (typeof tags === 'string') { tg = tags.toLowerCase(); }
      else if (Array.isArray(tags)) { tg = tags.join(',').toLowerCase(); }

      // Electronics: boox, pine tech, sony, jabra, or tech types
      if (v === 'boox' || v.indexOf('pine tech') > -1 ||
          v === 'sony' || v === 'jabra' ||
          t.indexOf('phone') > -1 || t.indexOf('reader') > -1 ||
          t.indexOf('speaker') > -1 || t.indexOf('cable') > -1 ||
          t.indexOf('electronic') > -1 || t.indexOf('gaming') > -1 ||
          tg.indexOf('ptg') > -1 || tg.indexOf('boox') > -1) {
        return 'brand-electronics';
      }
      return null;
    }

    // Try sync detection from embedded JSON
    var detected = false;
    var scripts = document.querySelectorAll('script[type="application/json"]');
    for (var i = 0; i < scripts.length; i++) {
      try {
        var d = JSON.parse(scripts[i].textContent);
        if (d && d.product) {
          var cls = classify(d.product.vendor, d.product.type, d.product.tags);
          if (cls) { b.classList.add(cls); detected = true; }
          break;
        }
      } catch(e) {}
    }

    // Also try URL-based detection as fast fallback
    if (!detected) {
      var slug = p.toLowerCase();
      if (slug.indexOf('boox') > -1 || slug.indexOf('tab-') > -1 ||
                 slug.indexOf('phone') > -1 || slug.indexOf('speaker') > -1 ||
                 slug.indexOf('cable') > -1 || slug.indexOf('case-') > -1) {
        b.classList.add('brand-electronics'); detected = true;
      }
    }

    // Async fallback: fetch product JSON
    if (!detected) {
      fetch(p + '.json').then(function(r){return r.json()}).then(function(data){
        var pr = data.product;
        var cls = classify(pr.vendor, pr.type, pr.tags);
        if (cls) { b.classList.add(cls); }
        else { b.classList.add('brand-electronics'); }
      }).catch(function(){ b.classList.add('brand-electronics'); });
    }
  }

  // Cart page - default to electronics (dark) styling
  if (p.indexOf('/cart') === 0) {
    b.classList.add('brand-electronics');
  }
})();
